// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2029-26935
// Variant: Size=Full screen sheet
import { useTranslation } from 'react-i18next'

function CompletedIcon() {
  return (
    <div className="flex items-center justify-center size-11">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <rect x="0.25" y="0.25" width="39.5" height="39.5" rx="19.75" fill="#FFCC00"/>
        <rect x="0.25" y="0.25" width="39.5" height="39.5" rx="19.75" stroke="#BA8200" strokeWidth="0.5"/>
        <path d="M12.5 20.8898L17.2956 26.8272C17.5632 27.1586 18.0766 27.131 18.3073 26.7729L27.5 12.5" stroke="#17181A" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    </div>
  )
}

function CancelledIcon() {
  return (
    <div className="flex items-center justify-center size-11">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <rect width="40" height="40" rx="20" fill="#121212"/>
        <path d="M9.5 20H30.5" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    </div>
  )
}

function PrebookedIcon() {
  return (
    <div className="flex items-center justify-center p-0.5 size-11 rounded-full">
      <div className="bg-[#121212] flex items-center justify-center p-2 rounded-full size-10">
        <svg width="15" height="16" viewBox="0 0 15.0713 16.001" fill="none" aria-hidden="true">
          <path d="M4.45215 7.09766C6.911 7.09766 8.90416 9.09049 8.9043 11.5488C8.9043 14.0073 6.91109 16.001 4.45215 16.001C1.99328 16.0009 0 14.0072 0 11.5488C0.000141755 9.09054 1.99337 7.09774 4.45215 7.09766ZM4.81445 0C5.10003 0 5.24317 0 5.35156 0.0556641C5.44675 0.104798 5.5237 0.183326 5.57129 0.279297C5.62542 0.388604 5.62283 0.531739 5.61816 0.817383L5.61133 1.22656C5.60822 1.41683 5.60748 1.51212 5.64355 1.58496C5.6753 1.64893 5.72656 1.70164 5.79004 1.73438C5.86223 1.77147 5.95751 1.77148 6.14746 1.77148H9.59863C9.7834 1.77148 9.87621 1.77104 9.94727 1.73535C10.0098 1.70388 10.0613 1.65378 10.0938 1.5918C10.1307 1.52135 10.1318 1.42883 10.1348 1.24414L10.1426 0.791016C10.1471 0.513734 10.1497 0.375255 10.2051 0.269531C10.2538 0.176545 10.3301 0.100937 10.4238 0.053711C10.5304 0.0000627254 10.6692 0 10.9463 0H11.1357C11.4213 0 11.5645 0 11.6729 0.0556641C11.7681 0.104766 11.845 0.183335 11.8926 0.279297C11.9467 0.388593 11.9451 0.531764 11.9404 0.817383L11.9326 1.26074C11.9297 1.44078 11.9283 1.53096 11.9629 1.60254C11.9931 1.66513 12.0435 1.71767 12.1045 1.75098C12.1743 1.78898 12.2651 1.79174 12.4463 1.79785C12.4833 1.7991 12.5099 1.80016 12.5195 1.80078C12.816 1.82071 13.1133 1.86481 13.4062 1.98438C14.0668 2.25399 14.5915 2.77115 14.8652 3.42188C14.9866 3.71044 15.0315 4.00291 15.0518 4.29492C15.071 4.57225 15.0713 4.90759 15.0713 5.2959V11.3809C15.0713 11.8476 15.0705 12.2503 15.043 12.582C15.0139 12.9322 14.9507 13.2811 14.7773 13.6162C14.5189 14.1159 14.1058 14.5217 13.5986 14.7764C13.2585 14.9471 12.9042 15.0105 12.5488 15.0391C12.2122 15.0661 11.8037 15.0664 11.3301 15.0664H10.2676C9.98607 15.0664 9.84483 15.0665 9.7373 15.0117C9.64277 14.9635 9.56575 14.8865 9.51758 14.792C9.46282 14.6845 9.46289 14.5432 9.46289 14.2617V14.0996C9.46289 13.8181 9.46279 13.6769 9.51758 13.5693C9.56577 13.4748 9.64277 13.3978 9.7373 13.3496C9.84483 13.2948 9.98607 13.2949 10.2676 13.2949H11.2949C11.8132 13.2949 12.1486 13.2949 12.4033 13.2744C12.6472 13.2548 12.7378 13.2205 12.7822 13.1982C12.9512 13.1133 13.0887 12.9781 13.1748 12.8115C13.1974 12.7678 13.231 12.6787 13.251 12.4385C13.2718 12.1875 13.2725 11.8573 13.2725 11.3467V5.32422C13.2725 4.89985 13.2723 4.62579 13.2578 4.41602C13.2438 4.2141 13.2196 4.13646 13.2041 4.09961C13.1128 3.88286 12.9379 3.7109 12.7178 3.62109C12.6803 3.60583 12.6023 3.58213 12.3975 3.56836C12.1844 3.55404 11.9057 3.55371 11.4746 3.55371H4.2832C3.85211 3.55371 3.57337 3.55404 3.36035 3.56836C3.15572 3.58214 3.07742 3.60584 3.04004 3.62109C2.82007 3.71097 2.64494 3.8829 2.55371 4.09961C2.53822 4.13646 2.51398 4.2141 2.5 4.41602C2.48549 4.62579 2.48535 4.89987 2.48535 5.32422V5.60645C2.48535 5.88795 2.48545 6.0292 2.43066 6.13672C2.38247 6.23125 2.30548 6.30827 2.21094 6.35645C2.10349 6.41114 1.96275 6.41113 1.68164 6.41113H1.49219C1.21074 6.41113 1.06943 6.4112 0.961914 6.35645C0.867364 6.30827 0.79038 6.23126 0.742188 6.13672C0.687403 6.0292 0.6875 5.88795 0.6875 5.60645V5.2959C0.687489 4.90759 0.687824 4.57225 0.707031 4.29492C0.727271 4.00292 0.771256 3.71043 0.892578 3.42188C1.16633 2.771 1.69182 2.25399 2.35254 1.98438C2.64544 1.86489 2.94188 1.82071 3.23828 1.80078C3.24673 1.80021 3.26895 1.79994 3.2998 1.79883C3.4761 1.79247 3.56437 1.78851 3.63281 1.75195C3.6927 1.71988 3.74251 1.66986 3.77344 1.60938C3.80873 1.5402 3.81064 1.45241 3.81348 1.27734L3.82129 0.791016C3.82578 0.513988 3.82756 0.375223 3.88281 0.269531C3.93156 0.176494 4.00872 0.100939 4.10254 0.053711C4.20914 0.0000955 4.34777 0 4.625 0H4.81445ZM7.33496 9.81543C7.0797 9.54746 6.65571 9.53675 6.3877 9.79199L3.95215 12.1104L2.83789 11.1416C2.5586 10.8988 2.13545 10.9278 1.89258 11.207C1.64972 11.4863 1.6797 11.9095 1.95898 12.1523L3.53418 13.5225C3.79504 13.7491 4.18523 13.7402 4.43555 13.502L7.3125 10.7627C7.58042 10.5074 7.59018 10.0834 7.33496 9.81543Z" fill="white"/>
        </svg>
      </div>
    </div>
  )
}

function CarIcon() {
  const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'

  // Only taxi-stockholm ships taxi-booking-status.png, so every Svea theme — and
  // the embed, which forces CONFIG.svea_module on — renders a broken image here.
  // Fall back to the same theme's own car icon rather than borrowing another
  // theme's status image: that one has the operator's livery printed on it, so
  // reusing it across themes would show the wrong brand. Remove this once each
  // theme has its own taxi-booking-status.png.
  const handleError = event => {
    if (event.target.dataset.fallbackApplied) return // fallback missing too — stop, don't loop
    event.target.dataset.fallbackApplied = 'true'
    event.target.src = `/app/themes/${theme}/static/img/car-icons/taxi.png`
  }

  return (
    <div className="overflow-hidden relative size-11">
      <img
        src={`/app/themes/${theme}/static/img/taxi-booking-status.png`}
        onError={handleError}
        alt=""
        className="absolute w-14 h-14 object-cover pointer-events-none"
        style={{ top: 'calc(50% - 6px)', left: '50%', transform: 'translate(-50%, -50%)' }}
      />
    </div>
  )
}

// booking.originLocation / destinationLocation come from the API as flat objects
function getAddressString(location) {
  if (!location) return ''
  if (location.poiName && location.locationType !== 'STREET') return location.poiName
  const parts = []
  if (location.streetName) {
    let s = location.streetName
    if (location.streetNumber) s += ` ${location.streetNumber}`
    parts.push(s)
  }
  if (location.city) parts.push(location.city)
  return parts.join(', ')
}

const CANCELLED_CODES = [130, 190, 220, 230, 610, 620, 630]

function StatusIcon({ booking }) {
  const code = Number(booking?.bookingStatus?.statusCode)
  const isPrebook = booking?.bookingType === 'PRE_BOOKING'

  if (CANCELLED_CODES.includes(code)) return <CancelledIcon />
  if (code === 510) return <CompletedIcon />
  if (code === 120 && isPrebook) return <PrebookedIcon />
  return <CarIcon />
}

function StatusTitle({ booking, t }) {
  const code = Number(booking?.bookingStatus?.statusCode)
  const isPrebook = booking?.bookingType === 'PRE_BOOKING'
  const plate = booking?.bookingStatus?.vehiclePlate

  if (code === 620) return <>{t('status-header-no-show')}</>
  if (code === 630) return <>{t('status-header-annulled')}</>
  if (code === 130) return <>{t('status-header-rejected')}</>
  if (code === 190) return <>{t('status-header-failed')}</>
  if ([220, 230, 610].includes(code)) return <>{t('status-header-cancelled')}</>
  if (code === 510) return <>{t('status-header-completed')}</>
  if (code === 410) return <>{t('status-header-en-route')}</>
  if (code === 320) return plate
    ? <>{t('status-header-plate-prefix')}<span className="text-secondary">{plate}</span>{t('status-header-at-pickup-suffix')}</>
    : <>{t('status-header-at-pickup')}</>
  if (code === 315) return plate
    ? <>{t('status-header-plate-prefix')}<span className="text-secondary">{plate}</span>{t('status-header-approaching-suffix')}</>
    : <>{t('status-header-approaching')}</>
  if (code === 310) return plate
    ? <>{t('status-header-plate-prefix')}<span className="text-secondary">{plate}</span>{t('status-header-dispatched-suffix')}</>
    : <>{t('status-header-dispatched')}</>
  if (code === 240) return <>{t('status-header-cancellation-rejected')}</>
  if (code === 210) return <>{t('status-header-cancellation-requested')}</>
  if (code === 110) return <>{t('status-header-received')}</>
  if (code === 120 && isPrebook) return <>{t('status-pre-booked')}</>
  return <>{t('status-searching')}</>
}

function StatusSubtitle({ booking, t }) {
  const code = Number(booking?.bookingStatus?.statusCode)
  const isPrebook = booking?.bookingType === 'PRE_BOOKING'
  const origin = getAddressString(booking?.originLocation)
  const dest = getAddressString(booking?.destinationLocation)

  if ([220, 230, 610, 620].includes(code)) return <>{t('status-subtitle-cancelled')}</>
  if (code === 510) return <>{t('status-subtitle-completed')}</>
  if (code === 410) return <>{dest ? t('status-subtitle-en-route-with-destination', { destination: dest }) : t('status-subtitle-en-route')}</>
  if (code === 320) return <>{origin ? t('status-subtitle-at-pickup-with-address', { address: origin }) : t('status-subtitle-at-pickup')}</>
  if (code === 315) return <>{origin ? t('status-subtitle-approaching-with-address', { address: origin }) : t('status-subtitle-dispatched')}</>
  if (code === 310) return <>{origin ? t('status-subtitle-dispatched-with-address', { address: origin }) : t('status-subtitle-dispatched')}</>
  if (code === 110) return <>{t('status-subtitle-received')}</>
  if (code === 120 && isPrebook) return <>{t('status-subtitle-prebooked')}</>
  return <>{t('status-subtitle-searching')}</>
}

export default function BookingDoneHeader({ booking }) {
  const { t } = useTranslation()

  return (
    <div className="bg-surface-container-low w-full flex flex-col items-center px-6 pt-6 pb-8 gap-4">
      <StatusIcon booking={booking} />
      <div className="flex flex-col items-center gap-1 text-center w-full">
        <p className="text-[28px] font-bold leading-none text-on-surface w-full">
          <StatusTitle booking={booking} t={t} />
        </p>
        <p className="text-[17px] leading-[22px] text-on-surface-variant w-full">
          <StatusSubtitle booking={booking} t={t} />
        </p>
      </div>
    </div>
  )
}
